import React, { useState } from 'react';

const ConstructionTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Streamlining Projects for Faster, Cost-Effective Results",
      content: "Modern construction management focuses on optimizing processes to reduce timelines and budgets. Through advanced project management techniques, lean construction principles, and integrated technology solutions, projects can be completed up to 30% faster while reducing costs by 15-20%. Key strategies include Building Information Modeling (BIM) for better collaboration, prefabrication of components to minimize on-site work, and real-time project tracking through IoT sensors. These approaches not only accelerate project delivery but also enhance quality control and safety measures across all construction phases."
    },
    {
      title: "Sustainable Building: The Future of Construction",
      content: "Sustainability is transforming the construction industry with eco-friendly materials, energy-efficient designs, and waste reduction strategies. Green building certifications like LEED and BREEAM are becoming standard as the industry moves toward net-zero carbon emissions and circular economy principles. Modern sustainable construction incorporates passive design techniques, renewable energy integration, water conservation systems, and materials with low embodied carbon. Beyond environmental benefits, these practices result in healthier indoor environments, lower operating costs, and increased property values, making sustainability both an ethical choice and a smart financial decision."
    },
    {
      title: "Modern Construction Techniques: Materials Changing the Industry",
      content: "Innovative materials such as self-healing concrete, cross-laminated timber, and aerogels are revolutionizing construction. These materials offer enhanced durability, sustainability, and efficiency. Self-healing concrete contains bacteria that produce limestone to fill cracks, significantly extending structure lifespan. Cross-laminated timber provides a renewable alternative to steel and concrete with impressive strength and carbon sequestration capabilities. Additionally, 3D printing and modular construction techniques are changing how buildings are designed and assembled, allowing for greater precision, reduced waste, and faster completion times while enabling more complex architectural designs."
    }
  ];

  return (
    <div className="mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-center text-[#063970] mb-8">Construction Innovation Insights</h1>
      
      {/* Tab headers */}
      <div className="flex flex-col sm:flex-row border-b border-gray-200 mb-6">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`py-3 px-6 font-medium text-lg transition-all duration-300 ${
              activeTab === index
                ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                : 'text-gray-600 hover:text-blue-500 hover:bg-gray-50'
            }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      
      {/* Tab content */}
      <div className="p-6 bg-gray-50 rounded-lg">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">{tabs[activeTab].title}</h2>
        <p className="text-gray-700 leading-relaxed">{tabs[activeTab].content}</p>
      </div>
      
      {/* Additional information */}
      <div className="mt-8 p-6 bg-blue-50 rounded-lg border border-blue-100">
        <h3 className="text-xl font-semibold text-[#063970] mb-3">Industry Impact</h3>
        <p className="text-gray-700">
          These innovations are reshaping the construction landscape, offering solutions to traditional challenges
          while creating new opportunities for efficiency, sustainability, and design excellence. As technology continues
          to evolve, the industry is poised for even more transformative changes in the coming years.
        </p>
      </div>
    </div>
  );
};

export default ConstructionTabs;